(function () {
  const ENDPOINT = 'https://formsubmit.co/ajax/';
  const SUBJECT_TOKEN = /\[([^\]]+)\]/g;

  const buildSubject = (template, fields) =>
    template.replace(SUBJECT_TOKEN, (match, key) => {
      const value = fields[key.trim()];
      return value ? String(value) : '';
    }).trim();

  const collectFields = (form) => {
    const entries = Array.from(new FormData(form).entries())
      .filter(([key]) => !key.startsWith('_'))
      .map(([key, value]) => [key, String(value).trim()]);
    return Object.fromEntries(entries);
  };

  const normalizeUrls = (form, fields) => {
    const overrides = Array.from(form.querySelectorAll('[data-wf-url]'))
      .filter((input) => input.name && fields[input.name])
      .map((input) => {
        const value = fields[input.name];
        return [input.name, /^https?:\/\//i.test(value) ? value : `https://${value}`];
      });
    return { ...fields, ...Object.fromEntries(overrides) };
  };

  const findReplyTo = (form) => {
    const emailInput = form.querySelector('input[type="email"]');
    return emailInput ? emailInput.value.trim() : '';
  };

  const setStatus = (el, message, isError) => {
    el.textContent = message;
    el.classList.toggle('wholesale-form__status--error', Boolean(isError));
  };

  const showSuccessPanel = (form, panel) => {
    form.classList.add('is-success');
    panel.focus({ preventScroll: true });
    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const seconds = Number(panel.dataset.duration) || 0;
    if (seconds <= 0) return;

    window.clearTimeout(form.wfSuccessTimer);
    form.wfSuccessTimer = window.setTimeout(() => {
      form.classList.remove('is-success');
    }, seconds * 1000);
  };

  const showSuccess = (form, status) => {
    const panel = form.querySelector('[data-wf-success]');
    if (panel) {
      showSuccessPanel(form, panel);
      return;
    }
    setStatus(status, form.dataset.successMessage, false);
  };

  const submitForm = async (form) => {
    const fields = normalizeUrls(form, collectFields(form));
    const replyTo = findReplyTo(form);
    const { cc } = form.dataset;
    const payload = {
      ...fields,
      _subject: buildSubject(form.dataset.subject || 'New submission', fields),
      _template: 'table',
      _honey: form.querySelector('[name="_honey"]').value,
      ...(replyTo ? { _replyto: replyTo } : {}),
      ...(cc ? { _cc: cc } : {}),
    };

    const response = await fetch(ENDPOINT + encodeURIComponent(form.dataset.recipient), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const result = await response.json().catch(() => ({}));
    const succeeded = result.success === true || result.success === 'true';

    if (!response.ok || !succeeded) {
      throw new Error(result.message || `Request failed with status ${response.status}`);
    }
    return result;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const status = form.querySelector('[data-wf-status]');
    const button = form.querySelector('[data-wf-submit]');

    if (!form.reportValidity()) return;

    if (!form.dataset.recipient) {
      setStatus(status, form.dataset.errorMessage, true);
      return;
    }

    button.disabled = true;
    setStatus(status, '', false);

    try {
      await submitForm(form);
      form.reset();
      showSuccess(form, status);
    } catch (error) {
      console.error('Wholesale form submission failed:', error);
      const needsActivation = /activat/i.test(error.message);
      setStatus(status, needsActivation ? error.message : form.dataset.errorMessage, true);
    } finally {
      button.disabled = false;
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-wholesale-form]:not([data-wf-ready])').forEach((form) => {
      form.setAttribute('data-wf-ready', '');
      form.addEventListener('submit', handleSubmit);
    });
  };

  const togglePreview = (event, isSelected) => {
    const panel = event.target.closest && event.target.closest('[data-wf-success]');
    if (!panel) return;
    panel.closest('[data-wholesale-form]').classList.toggle('is-success', isSelected);
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => togglePreview(event, true));
  document.addEventListener('shopify:block:deselect', (event) => togglePreview(event, false));
})();
